import { render, staticRenderFns } from "./linkDetail.vue?vue&type=template&id=f02eeed0&scoped=true&"
import script from "./linkDetail.vue?vue&type=script&lang=js&"
export * from "./linkDetail.vue?vue&type=script&lang=js&"
import style0 from "./linkDetail.vue?vue&type=style&index=0&id=f02eeed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f02eeed0",
  null
  
)

export default component.exports